import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" foo? ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" open browser ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" close browser ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" send message ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" bar ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(true)))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOpen(false)))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendMessage()))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isOpen), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, null, {
            default: _withCtx(() => [
              _createTextVNode(" isNative " + _toDisplayString(_ctx.isNative), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.checkRef), 1)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messagesRef, (item, index) => {
            return (_openBlock(), _createBlock(_component_ag_text, { key: index }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item), 1)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}